import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.webp';
import appStoreBadge from '../assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import { trackAppStoreClick } from '../analytics';

const navLinks = [
  { label: 'Home', hash: 'home' },
  { label: 'Features', hash: 'features' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const prefix = pathname === '/' ? '' : '/';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href={`${prefix}#home`} className="flex items-center gap-2">
              <img src={logo} alt="GymBud Pro" className="w-9 h-9 rounded-xl object-cover" />
            <span className="text-gray-900 font-bold text-lg tracking-tight">GymBud Pro</span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
              link.to ? (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={`${prefix}#${link.hash}`}
                  className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
                >
                  {link.label}
                </a>
              )
            )}
            <Link to="/privacy-policy" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors">
              Terms of Service
            </Link>
          </div>

          {/* CTA */}
          <a
            href="https://apps.apple.com/us/app/gymbud-pro/id6478331872"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackAppStoreClick('navbar')}
            className="hidden md:inline-block hover:opacity-80 hover:scale-105 transform transition-all duration-200"
          >
            <img src={appStoreBadge} alt="Download on the App Store" className="h-9 w-auto" />
          </a>

          {/* Mobile menu button */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-gray-500 hover:text-gray-900 p-2"
            aria-label="Toggle menu"
          >
            {open ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 pt-4 pb-6 space-y-4">
          {navLinks.map((link) =>
            link.to ? (
              <Link
                key={link.label}
                to={link.to}
                onClick={() => setOpen(false)}
                className="block text-gray-700 hover:text-gray-900 text-base font-medium"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={`${prefix}#${link.hash}`}
                onClick={() => setOpen(false)}
                className="block text-gray-700 hover:text-gray-900 text-base font-medium"
              >
                {link.label}
              </a>
            )
          )}
          <Link
            to="/privacy-policy"
            onClick={() => setOpen(false)}
            className="block text-gray-700 hover:text-gray-900 text-base font-medium"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-of-service"
            onClick={() => setOpen(false)}
            className="block text-gray-700 hover:text-gray-900 text-base font-medium"
          >
            Terms of Service
          </Link>
          <a
            href="https://apps.apple.com/us/app/gymbud-pro/id6478331872"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackAppStoreClick('navbar')}
            className="inline-block hover:opacity-80 hover:scale-105 transform transition-all duration-200 mt-2"
          >
            <img src={appStoreBadge} alt="Download on the App Store" className="h-10 w-auto" />
          </a>
        </div>
      )}
    </nav>
  );
}
